<template>
	<app-content class="h-panel">
		<Tabs :datas="tabDatas" v-model="selected"></Tabs>
		<div class="h-panel-body padding">
      <!-- 渲染当前路由匹配到的组件。路由变化时，该区域内容会相应更新 -->
			<router-view></router-view>
		</div>
	</app-content>
</template>
<script>
 /**
	 * 辅助核算类别
	 */
	export default {
		data() {
			return {
				selected: 'AccountingCategory',
				tabDatas: [{
					title: '辅助核算类别',
					key: 'AccountingCategory'
				}]
			};
		},
		watch: {
			// selected(val) {
			// 	if (val == 'AccountingCategory') {
			// 		this.$router.push({name: val})
			// 	} else {
			// 		this.$router.push({name: 'CategoryCustom', params: {id: val}})
			// 	}
			// }
      selected(val) {
        if (val == 'AccountingCategory') {
          this.$router.push({name: val}).catch(err => {})
        } else {
          this.$router.push({name: 'CategoryCustom', params: {id: val}}).catch(err => {})
        }
      }
		},
		mounted() {
			this.init();
		},
		methods: {
						/**
			 * 初始化组件数据
			 * 1. 检查当前路由名称，若为 'CategoryCustom' 则更新选中标签
			 * 2. 调用 API 获取辅助核算类别列表，并更新标签页数据
			 */
			init() {
				// 检查当前路由名称是否为 'CategoryCustom'
				// 使用 == 比较可能导致意外类型强制，建议使用 === 进行严格比较
				if (this.$route.name == 'CategoryCustom') {
					// 若为 'CategoryCustom' 路由，将选中标签更新为路由参数中的 id
					this.selected = this.$route.params.id
				}
				// 调用 API 获取辅助核算类别列表
				this.$api.setting.accountingCategory.list().then(({data}) => {
					// 遍历返回的数据，为每个辅助核算类别添加一个标签页
					data.forEach(val => {
						this.tabDatas.push({
							// 标签页标题为辅助核算类别的名称
							title: val.name,
							// 标签页的唯一标识为辅助核算类别的 id
							key: val.id
						})
					});
				});
			},

						/**
			 * 重新加载标签页数据
			 * 该方法会调用 API 获取最新的辅助核算类别列表，
			 * 并根据获取的数据重新生成标签页数据，更新当前组件的 tabDatas 属性。
			 */
			reloadTabs() {
				// 调用 API 获取最新的辅助核算类别列表
				this.$api.setting.accountingCategory.list().then(({data}) => {
					// 初始化标签页数据，包含默认的 '辅助核算类别' 标签
					let tabDatas = [{
						title: '辅助核算类别',
						key: 'AccountingCategory'
					}];
					// 遍历 API 返回的数据，为每个辅助核算类别添加一个标签页
					data.forEach(val => {
						tabDatas.push({
							// 标签页标题为辅助核算类别的名称
							title: val.name,
							// 标签页的唯一标识为辅助核算类别的 id
							key: val.id
						});
					});
					// 将重新生成的标签页数据赋值给当前组件的 tabDatas 属性
					this.tabDatas = tabDatas;
				});
			}

		}
	};
</script>
<style lang='less'>
	div.h-panel-bar {
		border-top: 0px solid #eeeeee
	}
</style>


